import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";
import Tendency_Icon from "@assets/svg/tendency_up.svg";

export const CourseContent = styled.div`
    display:flex;
    align-items: center;
    width:10px;
    justify-content: center;
    position: relative;

     span {
        display:none;
        bottom: 0%;
        left:14px;
        font-size:8px;
        width:10px;
    }

    svg{
        height:10px;
    }

    div{ 
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

export const DashList = styled.table`
    width:100%;
    margin-top: 1rem;
    border-collapse: collapse;

    td{
        font-size: 14px;
        padding:5px 10px;

        &:last-of-type{
            text-align: right;
        }
    }

    tr{
            background:#ffffff!important;
    }

    span{
        display:block;
        white-space: nowrap;
    }

    .width50{
        text-align: left!important;
        width:90%;
    }
`;

export const ModalWrapper = styled.div<{placement?:any}>`
    position: absolute;
`;